// extracted by mini-css-extract-plugin
module.exports = {"title":"_2r7nXB4D","subtitle":"Q82uQ1Z0","search":"_1ZtbZg2X","pagination":"_1htjwLLw"};